/**
 * Addresses that can only belong to OUR OWN test sign-ups.
 *
 * `blackhole.postmarkapp.com` is Postmark's sink: mail to it is accepted and
 * thrown away, which is exactly why QA signs up with it (the login code is read
 * back through the Postmark API). Nobody can receive anything there, and nobody
 * types it by accident.
 *
 * Why this exists (2026-10-04): a QA account is flagged `users.internal` by hand
 * a few minutes AFTER it signs up. In between, the server had already sent Meta
 * a CompleteRegistration for it and the browser had fired the Pixel and GA4 —
 * test sign-ups landed in the very dataset the ad account optimises on. Both
 * legs now go quiet for these addresses from the first event, and both read this
 * one list so they cannot drift apart.
 *
 * ⚠️ This silences ANALYTICS and nothing else. It must never be used to grant
 * anything — not `users.internal` (which lifts the read limits and hides a
 * payment from the CRM alerts and revenue reports), not the test plan. Anyone
 * may type any address at sign-up and soft signup does not verify it, which is
 * why the `test.uz` domain lost its entitlement on 2026-09-22
 * (`billing/test-plan-email.ts`). The worst a stranger gets from typing one of
 * these is that Meta does not hear about them.
 *
 * `test.uz`, the older QA domain, is deliberately NOT listed: its 25 accounts
 * are all flagged `internal` already, QA no longer signs up with it, and it is
 * the kind of address a real person does type to get past a form.
 */
const QA_EMAIL_DOMAINS = ['blackhole.postmarkapp.com'] as const;

export function isQaSinkEmail(email: string | null | undefined): boolean {
  if (!email) return false;
  const at = email.lastIndexOf('@');
  if (at < 0) return false;
  const domain = email
    .slice(at + 1)
    .trim()
    .toLowerCase();
  return (QA_EMAIL_DOMAINS as readonly string[]).includes(domain);
}
